/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PublishedCameraWatch } from '../models/published-camera-watch';
import { Camera } from '../models/camera';
import { Incident } from '../models/incident';
import { DataAnalysisTimeSeries } from '../models/data-analysis-time-series';
import { TimeSeriesDetailRequest } from '../models/time-series-detail-request';
@Injectable({
  providedIn: 'root',
})
class PublishedCameraWatchService extends __BaseService {
  static readonly PublishedCameraWatchGetAllPath = '/api/PublishedCameraWatch/GetAll';
  static readonly PublishedCameraWatchGetByIdPath = '/api/PublishedCameraWatch/GetById';
  static readonly PublishedCameraWatchCreatePath = '/api/PublishedCameraWatch/Create';
  static readonly PublishedCameraWatchUpdatePath = '/api/PublishedCameraWatch/Update';
  static readonly PublishedCameraWatchDeletePath = '/api/PublishedCameraWatch/Delete';
  static readonly PublishedCameraWatchGetByIdentifierPath = '/api/PublishedCameraWatch/GetByIdentifier/{identifier}';
  static readonly PublishedCameraWatchGetCameraPath = '/api/PublishedCameraWatch/GetCamera';
  static readonly PublishedCameraWatchGetIncidentPath = '/api/PublishedCameraWatch/GetIncident';
  static readonly PublishedCameraWatchGetIncidentsPath = '/api/PublishedCameraWatch/GetIncidents';
  static readonly PublishedCameraWatchGetDataPath = '/api/PublishedCameraWatch/GetData';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param customerId undefined
   */
  PublishedCameraWatchGetAllResponse(customerId?: null | number): __Observable<__StrictHttpResponse<Array<PublishedCameraWatch>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedCameraWatch/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PublishedCameraWatch>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  PublishedCameraWatchGetAll(customerId?: null | number): __Observable<Array<PublishedCameraWatch>> {
    return this.PublishedCameraWatchGetAllResponse(customerId).pipe(
      __map(_r => _r.body as Array<PublishedCameraWatch>)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetByIdParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchGetByIdResponse(params: PublishedCameraWatchService.PublishedCameraWatchGetByIdParams): __Observable<__StrictHttpResponse<PublishedCameraWatch>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedCameraWatch/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublishedCameraWatch>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetByIdParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchGetById(params: PublishedCameraWatchService.PublishedCameraWatchGetByIdParams): __Observable<PublishedCameraWatch> {
    return this.PublishedCameraWatchGetByIdResponse(params).pipe(
      __map(_r => _r.body as PublishedCameraWatch)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchCreateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchCreateResponse(params: PublishedCameraWatchService.PublishedCameraWatchCreateParams): __Observable<__StrictHttpResponse<PublishedCameraWatch>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/PublishedCameraWatch/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublishedCameraWatch>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchCreateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchCreate(params: PublishedCameraWatchService.PublishedCameraWatchCreateParams): __Observable<PublishedCameraWatch> {
    return this.PublishedCameraWatchCreateResponse(params).pipe(
      __map(_r => _r.body as PublishedCameraWatch)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchUpdateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchUpdateResponse(params: PublishedCameraWatchService.PublishedCameraWatchUpdateParams): __Observable<__StrictHttpResponse<PublishedCameraWatch>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/PublishedCameraWatch/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublishedCameraWatch>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchUpdateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchUpdate(params: PublishedCameraWatchService.PublishedCameraWatchUpdateParams): __Observable<PublishedCameraWatch> {
    return this.PublishedCameraWatchUpdateResponse(params).pipe(
      __map(_r => _r.body as PublishedCameraWatch)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchDeleteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchDeleteResponse(params: PublishedCameraWatchService.PublishedCameraWatchDeleteParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/PublishedCameraWatch/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchDeleteParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  PublishedCameraWatchDelete(params: PublishedCameraWatchService.PublishedCameraWatchDeleteParams): __Observable<Blob> {
    return this.PublishedCameraWatchDeleteResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param identifier undefined
   */
  PublishedCameraWatchGetByIdentifierResponse(identifier: string): __Observable<__StrictHttpResponse<PublishedCameraWatch>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedCameraWatch/GetByIdentifier/${encodeURIComponent(String(identifier))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublishedCameraWatch>;
      })
    );
  }
  /**
   * @param identifier undefined
   */
  PublishedCameraWatchGetByIdentifier(identifier: string): __Observable<PublishedCameraWatch> {
    return this.PublishedCameraWatchGetByIdentifierResponse(identifier).pipe(
      __map(_r => _r.body as PublishedCameraWatch)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetCameraParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetCameraResponse(params: PublishedCameraWatchService.PublishedCameraWatchGetCameraParams): __Observable<__StrictHttpResponse<Camera>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteId != null) __params = __params.set('siteId', params.siteId.toString());
    if (params.identifier != null) __params = __params.set('identifier', params.identifier.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedCameraWatch/GetCamera`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Camera>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetCameraParams` containing the following parameters:
   *
   * - `siteId`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetCamera(params: PublishedCameraWatchService.PublishedCameraWatchGetCameraParams): __Observable<Camera> {
    return this.PublishedCameraWatchGetCameraResponse(params).pipe(
      __map(_r => _r.body as Camera)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetIncidentParams` containing the following parameters:
   *
   * - `incidentId`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetIncidentResponse(params: PublishedCameraWatchService.PublishedCameraWatchGetIncidentParams): __Observable<__StrictHttpResponse<Incident>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.incidentId != null) __params = __params.set('incidentId', params.incidentId.toString());
    if (params.identifier != null) __params = __params.set('identifier', params.identifier.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedCameraWatch/GetIncident`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Incident>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetIncidentParams` containing the following parameters:
   *
   * - `incidentId`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetIncident(params: PublishedCameraWatchService.PublishedCameraWatchGetIncidentParams): __Observable<Incident> {
    return this.PublishedCameraWatchGetIncidentResponse(params).pipe(
      __map(_r => _r.body as Incident)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetIncidentsParams` containing the following parameters:
   *
   * - `statusId`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetIncidentsResponse(params: PublishedCameraWatchService.PublishedCameraWatchGetIncidentsParams): __Observable<__StrictHttpResponse<Array<Incident>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.statusId != null) __params = __params.set('statusId', params.statusId.toString());
    if (params.identifier != null) __params = __params.set('identifier', params.identifier.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedCameraWatch/GetIncidents`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Incident>>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetIncidentsParams` containing the following parameters:
   *
   * - `statusId`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetIncidents(params: PublishedCameraWatchService.PublishedCameraWatchGetIncidentsParams): __Observable<Array<Incident>> {
    return this.PublishedCameraWatchGetIncidentsResponse(params).pipe(
      __map(_r => _r.body as Array<Incident>)
    );
  }

  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetDataParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetDataResponse(params: PublishedCameraWatchService.PublishedCameraWatchGetDataParams): __Observable<__StrictHttpResponse<DataAnalysisTimeSeries>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;
    if (params.identifier != null) __params = __params.set('identifier', params.identifier.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/PublishedCameraWatch/GetData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DataAnalysisTimeSeries>;
      })
    );
  }
  /**
   * @param params The `PublishedCameraWatchService.PublishedCameraWatchGetDataParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `identifier`:
   */
  PublishedCameraWatchGetData(params: PublishedCameraWatchService.PublishedCameraWatchGetDataParams): __Observable<DataAnalysisTimeSeries> {
    return this.PublishedCameraWatchGetDataResponse(params).pipe(
      __map(_r => _r.body as DataAnalysisTimeSeries)
    );
  }
}

module PublishedCameraWatchService {

  /**
   * Parameters for PublishedCameraWatchGetById
   */
  export interface PublishedCameraWatchGetByIdParams {
    id?: number;
    customerId?: null | number;
  }

  /**
   * Parameters for PublishedCameraWatchCreate
   */
  export interface PublishedCameraWatchCreateParams {
    model: PublishedCameraWatch;
    customerId?: null | number;
  }

  /**
   * Parameters for PublishedCameraWatchUpdate
   */
  export interface PublishedCameraWatchUpdateParams {
    model: PublishedCameraWatch;
    id?: number;
    customerId?: null | number;
  }

  /**
   * Parameters for PublishedCameraWatchDelete
   */
  export interface PublishedCameraWatchDeleteParams {
    id?: number;
    customerId?: null | number;
  }

  /**
   * Parameters for PublishedCameraWatchGetCamera
   */
  export interface PublishedCameraWatchGetCameraParams {
    siteId?: number;
    identifier?: null | string;
  }

  /**
   * Parameters for PublishedCameraWatchGetIncident
   */
  export interface PublishedCameraWatchGetIncidentParams {
    incidentId?: number;
    identifier?: null | string;
  }

  /**
   * Parameters for PublishedCameraWatchGetIncidents
   */
  export interface PublishedCameraWatchGetIncidentsParams {
    statusId?: null | number;
    identifier?: null | string;
  }

  /**
   * Parameters for PublishedCameraWatchGetData
   */
  export interface PublishedCameraWatchGetDataParams {
    request: TimeSeriesDetailRequest;
    identifier?: null | string;
  }
}

export { PublishedCameraWatchService }
